import { render, staticRenderFns } from "./CandidatePostulation.vue?vue&type=template&id=14a1e8c3&scoped=true&"
import script from "./CandidatePostulation.vue?vue&type=script&lang=js&"
export * from "./CandidatePostulation.vue?vue&type=script&lang=js&"
import style0 from "./CandidatePostulation.vue?vue&type=style&index=0&id=14a1e8c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a1e8c3",
  null
  
)

export default component.exports